import { useQuery } from '@tanstack/react-query';
import { milestoneTemplateApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useMilestoneTemplates() {
  return useQuery({
    queryKey: queryKeys.milestoneTemplates.list(),
    queryFn: ({ signal }) =>
      milestoneTemplateApiClient.getTemplates(toCancelToken(signal)),
    staleTime: 5 * 60_000,
    meta: { errorContext: 'milestone templates' },
  });
}
